import './PriceImprovementBlotter.scss';
import classnames from 'classnames';
import { FC } from 'react';

import { AcknowledgePanel } from './acknowledgePanel/AcknowledgePanel';
import { PriceImprovementBlotterFilter } from './filter/Filter';
import { PriceImprovementBlotterServerSideGrid } from './Grid';
import { PriceImprovementBlotterPagination } from './Pagination';
import { Panel } from './panel/PriceImprovementBlotterPanel';
import type { PriceImprovementBlotterProps } from './PriceImprovementBlotter.connect';
import { connectPriceImprovementBlotter } from './PriceImprovementBlotter.connect';

export const PriceImprovementBlotterComponent: FC<PriceImprovementBlotterProps> = ({
  canAcknowledge,
  isBlotterPanelActive,
}) => {
  return (
    <div className="container-fluid px-0 h-100 gap-4" data-e2e="price-improvement-blotter-container">
      <div className="d-flex flex-column h-100">
        {canAcknowledge ? <AcknowledgePanel /> : <PriceImprovementBlotterFilter />}
        <div className="d-flex flex-row flex-grow-1 min-h-0 vh-100">
          <div
            className={classnames(
              'd-flex flex-column p-0',
              isBlotterPanelActive ? 'col-md-6 col-lg-8 col-xl-9 col-xxl-9' : 'col-12',
            )}
          >
            <PriceImprovementBlotterServerSideGrid
              logAnalyticName="Blotter My price improvements"
              name="priceImprovementBlotter"
            />
            <PriceImprovementBlotterPagination />
          </div>
          {isBlotterPanelActive && (
            <div className="col-md-6 col-lg-4 col-xl-3 col-xxl-3 px-0">
              <Panel />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const ConnectedPriceImprovementBlotter = connectPriceImprovementBlotter(PriceImprovementBlotterComponent);
